/**
 * Header Mega Menu and Language Switcher
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Set header height CSS variable for mega menu positioning
    function setHeaderHeight() {
        const header = document.querySelector('.dg-header');
        if (header) {
            const headerHeight = header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

            // Bottom edge of the header in the viewport. Equals the header height
            // in the usual case, but grows while the announcement banner above it
            // is still on screen. The fixed mobile nav panel and the tablet mega
            // menus are positioned from this value.
            const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
            document.documentElement.style.setProperty('--dg-header-bottom', `${headerBottom}px`);
        }
    }

    // Set on load, resize and scroll (the banner scrolls away, the header sticks)
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    if (document.querySelector('[data-dg-announcement]')) {
        let headerOffsetTicking = false;
        window.addEventListener('scroll', function () {
            if (headerOffsetTicking) {
                return;
            }
            headerOffsetTicking = true;
            window.requestAnimationFrame(function () {
                setHeaderHeight();
                headerOffsetTicking = false;
            });
        }, { passive: true });
    }
    
    // Mobile Menu Toggle
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const headerNav = document.querySelector('.header-nav');
    
    if (mobileMenuToggle && headerNav) {
        mobileMenuToggle.addEventListener('click', function() {
            const isOpen = headerNav.classList.contains('is-open');
            
            if (isOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
        
        // Close mobile menu on escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && headerNav.classList.contains('is-open')) {
                closeMobileMenu();
            }
        });
        
        // Handle mobile mega menu toggles
        const mobileMenuItems = document.querySelectorAll('.has-mega-menu');
        mobileMenuItems.forEach(item => {
            const link = item.querySelector(':scope > a');
            const dropdown = item.querySelector('.mega-menu-dropdown');
            
            if (link && dropdown) {

                // ── Caret injection ──────────────────────────────────────────
                // Only inject once; guard against duplicate runs
                if (!link.querySelector('.mobile-menu-caret')) {
                    const caret = document.createElement('span');
                    caret.className = 'mobile-menu-caret material-symbols-rounded';
                    caret.setAttribute('aria-hidden', 'true');
                    caret.textContent = 'expand_more';
                    link.appendChild(caret);
                }

                // Sync aria-expanded on the link with the dropdown open state
                const syncAria = (isOpen) => {
                    link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                };
                // Initialise
                syncAria(dropdown.classList.contains('is-open'));

                // Helper: open/close this dropdown and sync state
                const openDropdown = () => {
                    dropdown.classList.add('is-open');
                    syncAria(true);
                };
                const closeDropdown = () => {
                    dropdown.classList.remove('is-open');
                    syncAria(false);
                };
                const closeOthers = () => {
                    document.querySelectorAll('.has-mega-menu').forEach(other => {
                        if (other !== item) {
                            const otherDd = other.querySelector('.mega-menu-dropdown');
                            const otherLink = other.querySelector(':scope > a');
                            if (otherDd) otherDd.classList.remove('is-open');
                            if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
                        }
                    });
                };

                // Use touchstart for better mobile responsiveness
                let touchHandled = false;
                
                link.addEventListener('touchstart', function(e) {
                    if (window.innerWidth <= 1024) {
                        e.preventDefault();
                        touchHandled = true;
                        
                        const isOpen = dropdown.classList.contains('is-open');
                        closeOthers();
                        
                        if (!isOpen) {
                            openDropdown();
                        } else {
                            closeDropdown();
                        }
                    }
                }, { passive: false });
                
                link.addEventListener('click', function(e) {
                    if (window.innerWidth <= 1024) {
                        e.preventDefault();
                        
                        // If touch was handled, don't process click
                        if (touchHandled) {
                            touchHandled = false;
                            return;
                        }
                        
                        const isOpen = dropdown.classList.contains('is-open');
                        closeOthers();
                        
                        if (!isOpen) {
                            openDropdown();
                        } else {
                            closeDropdown();
                        }
                    }
                });

                // Keyboard: Enter / Space toggles on mobile
                link.addEventListener('keydown', function(e) {
                    if ((e.key === 'Enter' || e.key === ' ') && window.innerWidth <= 1024) {
                        e.preventDefault();
                        const isOpen = dropdown.classList.contains('is-open');
                        closeOthers();
                        if (!isOpen) { openDropdown(); } else { closeDropdown(); }
                    }
                    if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
                        closeDropdown();
                        link.focus();
                    }
                });
            }
        });
    }
    
    function openMobileMenu() {
        headerNav.classList.add('is-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }
    
    function closeMobileMenu() {
        headerNav.classList.remove('is-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        
        // Close all mega menu dropdowns and reset their aria-expanded
        document.querySelectorAll('.mega-menu-dropdown.is-open').forEach(dd => {
            dd.classList.remove('is-open');
        });
        document.querySelectorAll('.has-mega-menu > a[aria-expanded="true"]').forEach(link => {
            link.setAttribute('aria-expanded', 'false');
        });
    }
    
    // Language Switcher
    const languageSwitcher = document.querySelector('.language-switcher');
    const languageToggle = document.querySelector('.language-switcher__toggle');
    const languageDropdown = document.querySelector('.language-switcher__dropdown');
    
    if (languageSwitcher && languageToggle && languageDropdown) {
        languageToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = languageSwitcher.classList.contains('is-open');
            
            if (isOpen) {
                closeLangSwitcher();
            } else {
                openLangSwitcher();
            }
        });
        
        // Close on outside click
        document.addEventListener('click', function(e) {
            if (!languageSwitcher.contains(e.target)) {
                closeLangSwitcher();
            }
        });
        
        // Close on escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && languageSwitcher.classList.contains('is-open')) {
                closeLangSwitcher();
                languageToggle.focus();
            }
        });
        
        // Highlight current language
            const btnText = languageToggle.querySelector('.btn__text');
            if (btnText) {
                const currentLang = btnText.textContent.toLowerCase();
                const langOptions = languageDropdown.querySelectorAll('.language-switcher__option');
                langOptions.forEach(option => {
                    const optionLang = option.dataset.lang;
                    if (optionLang === currentLang) {
                        option.classList.add('is-active');
                    }
                });
            }
    }
    
    function openLangSwitcher() {
        languageSwitcher.classList.add('is-open');
        languageToggle.setAttribute('aria-expanded', 'true');
    }
    
    function closeLangSwitcher() {
        languageSwitcher.classList.remove('is-open');
        languageToggle.setAttribute('aria-expanded', 'false');
    }
    
    // Mega Menu Interactions
    const megaMenuItems = document.querySelectorAll('.has-mega-menu');
    
    megaMenuItems.forEach(item => {
        const link = item.querySelector('a');
        const dropdown = item.querySelector('.mega-menu-dropdown');
        
        if (!dropdown) return;
        
        // Position featured content
        const menuId = link.closest('li').id;
        const featured = dropdown.querySelector('.mega-menu-featured');
        
        if (featured) {
            // Move featured content to the end of mega-menu-container
            const container = dropdown.querySelector('.mega-menu-container');
            if (container) {
                container.appendChild(featured);
            }
        }
        
        // Keyboard navigation
        link.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const isExpanded = item.classList.contains('is-open');
                
                if (isExpanded) {
                    closeMegaMenu(item);
                } else {
                    openMegaMenu(item);
                }
            }
        });
        
        // Close on escape
        item.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && item.classList.contains('is-open')) {
                closeMegaMenu(item);
                link.focus();
            }
        });
        
        // Mouse interactions
        item.addEventListener('mouseenter', function() {
            openMegaMenu(item);
        });
        
        item.addEventListener('mouseleave', function() {
            closeMegaMenu(item);
        });
    });
    
    function openMegaMenu(item) {
        // Close other mega menus
        megaMenuItems.forEach(otherItem => {
            if (otherItem !== item) {
                closeMegaMenu(otherItem);
            }
        });
        
        item.classList.add('is-open');
        const link = item.querySelector('a');
        if (link) {
            link.setAttribute('aria-expanded', 'true');
        }
    }
    
    function closeMegaMenu(item) {
        item.classList.remove('is-open');
        const link = item.querySelector('a');
        if (link) {
            link.setAttribute('aria-expanded', 'false');
        }
    }
    
    // Close mega menus on outside click
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.has-mega-menu')) {
            megaMenuItems.forEach(item => {
                closeMegaMenu(item);
            });
        }
    });
    
    // Sticky header scroll effect
    let lastScroll = 0;
    const header = document.querySelector('.dg-header');
    
    window.addEventListener('scroll', function() {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll <= 0) {
            header.classList.remove('scroll-up');
            header.classList.remove('scroll-down');
            return;
        }
        
        if (currentScroll > lastScroll && !header.classList.contains('scroll-down')) {
            // Scrolling down
            header.classList.remove('scroll-up');
            header.classList.add('scroll-down');
        } else if (currentScroll < lastScroll && header.classList.contains('scroll-down')) {
            // Scrolling up
            header.classList.remove('scroll-down');
            header.classList.add('scroll-up');
        }
        
        lastScroll = currentScroll;
    });
});